import { render, staticRenderFns } from "./LayoutNavbar.vue?vue&type=template&id=56e38aa5&"
import script from "./LayoutNavbar.vue?vue&type=script&lang=js&"
export * from "./LayoutNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports